import ResizedImageId from '../constants/ResizedImageId';
import IArtisanProject from '../interfaces/IArtisanProject';

export const getArtisanProjectWithImageUrl = async (
    URLGetter: (storageId: string, slug?: string) => Promise<string | undefined>,
    artisanProject: IArtisanProject,
): Promise<IArtisanProject> => ({
    ...artisanProject,
    ...(artisanProject.fields.portfolioData?.images && {
        fields: {
            ...artisanProject.fields,
            portfolioData: {
                ...artisanProject.fields.portfolioData,
                images: await Promise.all(artisanProject.fields.portfolioData.images
                    .map(async ({ id, slug, resized }) => ({
                        id,
                        url: await URLGetter(id, slug),
                        ...(resized && {
                            resized: {
                                ...resized,
                                ...(resized[ResizedImageId.L] && {
                                    [ResizedImageId.L]: {
                                        ...resized[ResizedImageId.L],
                                        url: await URLGetter(id, resized[ResizedImageId.L].slug),
                                    },
                                }),
                                ...(resized[ResizedImageId.Lw] && {
                                    [ResizedImageId.Lw]: {
                                        ...resized[ResizedImageId.Lw],
                                        url: await URLGetter(id, resized[ResizedImageId.Lw].slug),
                                    },
                                }),
                                ...(resized[ResizedImageId.M] && {
                                    [ResizedImageId.M]: {
                                        ...resized[ResizedImageId.M],
                                        url: await URLGetter(id, resized[ResizedImageId.M].slug),
                                    },
                                }),
                                ...(resized[ResizedImageId.Mw] && {
                                    [ResizedImageId.Mw]: {
                                        ...resized[ResizedImageId.Mw],
                                        url: await URLGetter(id, resized[ResizedImageId.Mw].slug),
                                    },
                                }),
                                ...(resized[ResizedImageId.S] && {
                                    [ResizedImageId.S]: {
                                        ...resized[ResizedImageId.S],
                                        url: await URLGetter(id, resized[ResizedImageId.S].slug),
                                    },
                                }),
                                ...(resized[ResizedImageId.Sw] && {
                                    [ResizedImageId.Sw]: {
                                        ...resized[ResizedImageId.Sw],
                                        url: await URLGetter(id, resized[ResizedImageId.Sw].slug),
                                    },
                                }),
                            },
                        }),
                    }))),
            },
        },
    }),
});

export default getArtisanProjectWithImageUrl;
